import envConfig from '@/config/env'

/**
 * 根据当前域名获取对应的配置
 * @return {Object} 环境配置对象
 */
function getCurrentConfig() {
  const host = window.location.hostname

  // 开发环境
  if (host === envConfig.development.h5Domain) {
    return envConfig.development
  }

  // 测试环境
  if (host === envConfig.testing.h5Domain) {
    return envConfig.testing
  }

  // 正式环境（默认）
  return envConfig.production
}

/**
 * 获取API基础URL（包含/Frontend路径）
 * @return {string} API基础URL
 */
export function getApiBaseUrl() {
  const config = getCurrentConfig()
  return config.apiBaseUrl
}

/**
 * 获取API域名（不含/Frontend路径）
 * 用于拼接静态资源路径（如图片）
 * @return {string} API域名
 */
export function getApiDomain() {
  const config = getCurrentConfig()
  return config.apiDomain
}

/**
 * 处理图片URL，如果不是完整URL则拼接API域名
 * @param {string} imageUrl 图片路径
 * @return {string} 完整的图片URL
 */
export function getImageUrl(imageUrl) {
  if (!imageUrl) {
    return ''
  }

  // 检查是否已经包含http://或https://
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl
  }

  // 获取API域名
  const apiDomain = getApiDomain()

  // 拼接完整URL
  // 确保路径以/开头
  if (!imageUrl.startsWith('/')) {
    imageUrl = '/' + imageUrl
  }

  return apiDomain + imageUrl
}

/**
 * 批量处理图片URL数组
 * @param {Array<string>} imageUrls 图片路径数组
 * @return {Array<string>} 完整的图片URL数组
 */
export function getImageUrls(imageUrls) {
  if (!Array.isArray(imageUrls)) {
    return []
  }

  return imageUrls.map(url => getImageUrl(url))
}